<template>
  <div class="itemS sepBottom">
    <div class="S8 T1 title">{{ item.rechargeAmount }}财币</div>
    <div class="S4 T3 price">(￥{{ item.actualPaymentAmount }})</div>
    <div class="s4 T3 time">
      {{ dayjs(item.updateTime).format('YYYY-MM-DD') }}
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'

export default {
  props: {
    item: {
      type: Object
    }
  },
  methods: {
    dayjs
  }
}
</script>

<style scoped>
.itemS {
  position: relative;
  line-height: 88px;
  height: 88px;
  display: flex;
  flex-direction: row;
}

.time {
  position: absolute;
  right: 0px;
  margin-right: 30px;
}
.title {
  margin-left: 30px;
}

.price {
  margin-left: 15px;
}
</style>
